import { atom } from "jotai";

export const isDeleteCommentConfirmationModalOpenAtom = atom<number | null>(
	null,
);
